import { onPageLoad } from '../modules/page_lifecycle.js';

const QUERY_MODALS = [
  ['publications', 'publicationsModal'],
  ['about', 'aboutGwiModal']
];

function openModal(id) {
  const bootstrap = globalThis.bootstrap;
  const el = document.getElementById(id);
  if (el && bootstrap?.Modal) bootstrap.Modal.getOrCreateInstance(el).show();
}

export function bindModalsFromQueryParams() {
  onPageLoad(() => {
    const params = new URLSearchParams(window.location.search);
    QUERY_MODALS.forEach((row) => {
      if (params.has(row[0])) openModal(row[1]);
    });
  });
}
